import $ from 'jquery';

$(document).ready(function () {
	let lastScroll = 0,
		direction = '',
		menuHeight = $('.header-wrapper').height();

	$(window).on('scroll', function (e) {
		let scrollPos = window.scrollY;

		if ($(window).scrollTop() > 0) {
			$('.wrapper').addClass('show');
		} else {
			$('.wrapper').removeClass('show');
		}

		if (scrollPos > lastScroll) {
			direction = 'down';
		} else {
			direction = 'up';
		}

		lastScroll = scrollPos;

		if (direction === 'down' && scrollPos - 30 > menuHeight) {
			$('.header-wrapper').addClass('animate');
			$('.header-wrapper').removeClass('initial');
		} else if (direction === 'up') {
			$('.header-wrapper').removeClass('animate');
		}

		if (direction === 'up') {
			$('.header-wrapper').addClass('header-animated');
		}

		if (
			(direction === 'up' && scrollPos < menuHeight + 100) ||
			scrollPos === 0
		) {
			$('.header-wrapper').removeClass('header-animated');
			$('.header-wrapper').addClass('initial');
		}
	});

	$(window).on('scroll', function () {
		var win = $(this);
		if (win.width() <= 600) {
			$('.scrollDown').css('display', 'none');
		} else {
			if ($(this).scrollTop() > 200) {
				$('.scrollDown').fadeOut('slow');
			} else {
				$('.scrollDown').fadeIn('slow');
			}
		}
	});

	$('.scrollDown').on('click', function () {
		document.getElementById('scrollDownTo').scrollIntoView({
			behavior: 'smooth',
		});
	});
});
